import React from "react";

const UZORAK =
  /\*\*([^*]+)\*\*|\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)|(https?:\/\/[^\s]+)/g;

function razdvoji(tekst) {
  const dijelovi = [];
  let zadnji = 0;
  let podudaranje;

  UZORAK.lastIndex = 0;

  while ((podudaranje = UZORAK.exec(tekst)) !== null) {
    const [cijelo, podebljano, tekstLinka, urlLinka, goliUrl] = podudaranje;

    if (podudaranje.index > zadnji) {
      dijelovi.push({ vrsta: "tekst", sadrzaj: tekst.slice(zadnji, podudaranje.index) });
    }
    zadnji = podudaranje.index + cijelo.length;

    if (podebljano !== undefined) {
      dijelovi.push({ vrsta: "bold", sadrzaj: podebljano });
    } else if (tekstLinka !== undefined) {
      dijelovi.push({ vrsta: "link", sadrzaj: tekstLinka, url: urlLinka });
    } else {
      const visak = (goliUrl.match(/[.,;:!?)\]]+$/) || [""])[0];
      const url = visak ? goliUrl.slice(0, -visak.length) : goliUrl;
      dijelovi.push({ vrsta: "link", sadrzaj: url, url });
      zadnji -= visak.length;
    }
  }

  if (zadnji < tekst.length) {
    dijelovi.push({ vrsta: "tekst", sadrzaj: tekst.slice(zadnji) });
  }

  return dijelovi;
}

export function FormatiraniTekst({ tekst }) {
  if (!tekst) return null;

  return (
    <>
      {razdvoji(tekst).map((dio, i) => {
        if (dio.vrsta === "bold") {
          return <strong key={i}>{dio.sadrzaj}</strong>;
        }
        if (dio.vrsta === "link") {
          return (
            <a
              key={i}
              href={dio.url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              {dio.sadrzaj}
            </a>
          );
        }
        return <React.Fragment key={i}>{dio.sadrzaj}</React.Fragment>;
      })}
    </>
  );
}

export function tekstBezOznaka(tekst) {
  if (!tekst) return "";

  return tekst
    .replace(/\*\*([^*]+)\*\*/g, "$1")
    .replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g, "$1")
    .replace(/\s+/g, " ")
    .trim();
}
